<!-- Neptune design -->
@if (isRefreshedSolutionParticipationUIEnabled) {
<ng-container>
  @if (!noSolutionsPurchased) {
  <div id="sp-modal-body" class="w-full">
    @if (!isLoading) {
    <div id="solution-group-table">
      <div class="flex flex-col gap-3 w-full mb-6">
        <h2 class="text-base font-medium text-neptune-color-green-500">Purchased</h2>

        @if (purchasedSolutionGroupRows.length) {
        <div class="flex flex-col gap-3 w-full solution-group-table-purchased">
          @for (solutionGroupRow of purchasedSolutionGroupRows; track $index; let rowIndex = $index) {
            <div class="grid grid-cols-3 gap-3 w-full">
              @for (solutionGroup of solutionGroupRow; track solutionGroup.solutionGroup) {
                <div class="solution-group-card flex items-center justify-between gap-2 p-4 min-w-0 rounded-md border border-solid border-neptune-border-subtle bg-neptune-color-neutral-100"
                  [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'border-blue bg-neptune-color-primary-500 text-white' : ''">
                  <div class="flex flex-col gap-1 min-w-0">
                    <h2 class="text-sm font-medium truncate" [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'text-white' : 'text-neptune-default'">{{solutionGroup.solutionGroup}}</h2>
                    <div class="text-xs" [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'text-white' : 'text-neptune-color-fg-muted'">
                      Products : {{solutionGroup.countOfProducts}} | Distributed by other :
                      {{solutionGroup.otherDistributor ? 'Yes' : 'No'}}
                    </div>
                  </div>

                  <div class="shrink-0 cursor-pointer transition-transform duration-200" [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'rotate-180' : ''" (click)="toggleExpand(solutionGroup.solutionGroup, getRowKey('purchased', rowIndex))">
                    <svg width="24" height="12" class="sp-location-chevron" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6 4.85714L10.5 1" [attr.stroke]="isCardSelected(solutionGroup.solutionGroup) ? '#FFFFFF' : '#006BD3'" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                  </div>
                </div>
              }
            </div>

            @if (selectedRowKey === getRowKey('purchased', rowIndex) && selectedSolutionGroup) {
            <div class="w-full pr-8">
              <div class="sp-product-details-container flex flex-col gap-3 w-full max-w-full rounded-md border border-solid border-neptune-border-subtle overflow-hidden">
                <div class="flex items-center justify-between w-full">
                  <h2 class="text-base font-medium text-neptune-default">{{selectedSolutionGroup}}</h2>
                  <div class="pr-4 shrink-0 size-6 cursor-pointer close-icon" (click)="toggleExpand(selectedSolutionGroup, getRowKey('purchased', rowIndex))">
                    <img src="assets/close-icon.svg" alt="Close icon" class="size-6" />
                  </div>
                </div>

                @if (!shouldShowNoLocationsMessage) {
                <div class="w-full max-w-full overflow-hidden">
                  <app-location-product-details-table [productData]="productData" [rightSection]=false></app-location-product-details-table>
                </div>
                } @else {
                <ng-container *ngTemplateOutlet="neptuneNoLocationsPurchasedAnyProductsWithinGroupBlock"></ng-container>
                }
              </div>
            </div>
            }
          }
        </div>
        } @else {
        <div class="w-full text-center text-sm text-neptune-color-fg-muted">
          <h2 class="text-base font-normal">No Solution Groups Purchased</h2>
        </div>
        }
      </div>

      <div class="flex flex-col w-full">
        <h2 class="text-base font-medium text-neptune-color-red-500">Not Purchased</h2>

        @if (notPurchasedSolutionGroupRows.length) {
        <div class="flex flex-col gap-3 w-full">
          @for (solutionGroupRow of notPurchasedSolutionGroupRows; track $index; let rowIndex = $index) {
            <div class="grid grid-cols-3 gap-3 w-full">
              @for (solutionGroup of solutionGroupRow; track solutionGroup.solutionGroup) {
                <div class="solution-group-card flex items-center justify-between gap-2 p-4 min-w-0 rounded-md border border-solid border-neptune-border-subtle bg-neptune-subtle"
                  [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'border-blue bg-neptune-color-primary-500 text-white' : ''">
                  <div class="flex flex-col gap-1 min-w-0">
                    <h2 class="text-sm font-medium truncate" [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'text-white' : 'text-neptune-default'">{{solutionGroup.solutionGroup}}</h2>
                    <div class="text-xs" [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'text-white' : 'text-neptune-color-fg-muted'">
                      Products : {{solutionGroup.countOfProducts}} | Distributed by other :
                      {{solutionGroup.otherDistributor ? 'Yes' : 'No'}}
                    </div>
                  </div>

                  <div class="shrink-0 cursor-pointer transition-transform duration-200" [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'rotate-180' : ''" (click)="toggleExpand(solutionGroup.solutionGroup, getRowKey('notPurchased', rowIndex))">
                    <svg class="sp-location-chevron" width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6 4.85714L10.5 1" [attr.stroke]="isCardSelected(solutionGroup.solutionGroup) ? '#FFFFFF' : '#006BD3'" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                  </div>
                </div>
              }
            </div>

            @if (selectedRowKey === getRowKey('notPurchased', rowIndex) && selectedSolutionGroup) {
            <div class="w-full">
              <div class="sp-product-details-container flex flex-col gap-3 w-full max-w-full rounded-md border border-solid border-neptune-border-subtle p-4 overflow-hidden">
                <div class="flex items-center justify-between w-full">
                  <h2 class="text-base font-medium text-neptune-default">{{selectedSolutionGroup}}</h2>
                  <div class="pr-4 shrink-0 size-6 cursor-pointer close-icon" (click)="toggleExpand(selectedSolutionGroup, getRowKey('notPurchased', rowIndex))">
                    <img src="assets/close-icon.svg" alt="Close icon" class="size-6" />
                  </div>
                </div>

                @if (!shouldShowNoLocationsMessage) {
                <div class="w-full max-w-full overflow-hidden">
                  <app-location-product-details-table [productData]="productData" [rightSection]=false></app-location-product-details-table>
                </div>
                } @else {
                <ng-container *ngTemplateOutlet="neptuneNoLocationsPurchasedAnyProductsWithinGroupBlock"></ng-container>
                }
              </div>
            </div>
            }
          }
        </div>
        } @else {
        <div class="w-full text-center text-sm text-neptune-color-fg-muted">
          <h2 class="text-base font-normal">No Unpurchased Solution Groups</h2>
        </div>
        }
      </div>
    </div>
    } @else {
    <!-- Neptune skeleton loader -->
    <div class="flex flex-col gap-3 w-full animate-pulse">
      <div class="h-5 w-24 rounded bg-neptune-subtle"></div>
      <div class="grid grid-cols-3 gap-3 w-full">
        @for (card of skeletonCards; track card) {
        <div class="h-16 rounded-md bg-neptune-subtle"></div>
        }
      </div>
    </div>
    }

    <ng-template #neptuneNoLocationsPurchasedAnyProductsWithinGroupBlock>
      <div class="w-full text-center text-sm text-neptune-color-fg-muted">
        <h2 class="text-base font-normal">No locations have purchased any products within this group.</h2>
      </div>
    </ng-template>
  </div>
  } @else {
  <div class="w-full text-center text-sm text-neptune-color-fg-muted">
    <h2 class="text-base font-normal">No Solution Groups available</h2>
  </div>
  }
</ng-container>
} @else {

<!-- Legacy design -->
<div id="sp-modal-body" class="sp-modal-body" *ngIf="!noSolutionsPurchased; else noSolutionsMessageBlock">
  <div *ngIf="!isLoading; else loaderBlock">
    <div class="solution-group-section purchased-section">
      <h2 class="section-title purchased">Purchased</h2>

      <table class="solution-group-table" *ngIf="purchasedSolutionGroupRows.length; else noPurchasedSolutionGroupsBlock">
        <tbody>
          <ng-container *ngFor="let solutionGroupRow of purchasedSolutionGroupRows; let rowIndex = index">
            <tr>
              <ng-container *ngFor="let solutionGroup of solutionGroupRow">
                <td>
                  <div [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'active-card': '' " class="solution-group-card purchased-card">
                    <div class="sp-solution-group">
                      <div class="solution-group-name">
                        <h2>{{solutionGroup.solutionGroup}}</h2>
                      </div>

                      <div class="spacer"></div>

                      <div class="solution-bottom-row">
                        <div class="solution-summary">
                          Products : {{solutionGroup.countOfProducts}} | Distributed by other :
                          {{solutionGroup.otherDistributor ? 'Yes' : 'No'}}
                        </div>
                      </div>
                    </div>

                    <div class="expand-arrow" (click)="toggleExpand(solutionGroup.solutionGroup, getRowKey('purchased', rowIndex))">
                      <svg width="24" height="12" viewBox="0 0 24 12" fill="none" class="sp-location-chevron"
                        xmlns="http://www.w3.org/2000/svg">
                        <path id="DownChevron" d="M1.5 1L6 4.85714L10.5 1" stroke="#006BD3" stroke-width="1.5"
                          stroke-linecap="round" />
                      </svg>
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="solutionGroupRow.length < 3">
                <td *ngFor="let emptyCell of [].constructor(3 - solutionGroupRow.length)"></td>
              </ng-container>
            </tr>

            <tr *ngIf="selectedRowKey === getRowKey('purchased', rowIndex) && selectedSolutionGroup">
              <td colspan="3">
                <div class="product-details-container">
                  <div class="product-details-header">
                    <h2>{{selectedSolutionGroup}}</h2>
                    <div class="close-icon expand-close-icon" (click)="toggleExpand(selectedSolutionGroup, getRowKey('purchased', rowIndex))">
                      <img src="assets/close-icon.svg" alt="Close icon" />
                    </div>
                  </div>

                  <div class="product-details-table-container" *ngIf="!shouldShowNoLocationsMessage; else noLocationsPurchasedAnyProductsWithinGroupBlock">
                    <app-location-product-details-table [productData]="productData" [rightSection]=false></app-location-product-details-table>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="solution-group-section not-purchased-section">
      <h2 class="section-title not-purchased">Not Purchased</h2>

      <table class="solution-group-table" *ngIf="notPurchasedSolutionGroupRows.length; else noNotPurchasedSolutionGroupsBlock">
        <tbody>
          <ng-container *ngFor="let solutionGroupRow of notPurchasedSolutionGroupRows; let rowIndex = index">
            <tr>
              <ng-container *ngFor="let solutionGroup of solutionGroupRow">
                <td>
                  <div [ngClass]="isCardSelected(solutionGroup.solutionGroup) ? 'active-card': '' " class="solution-group-card not-purchased-card">
                    <div class="sp-solution-group">
                      <div class="solution-group-name">
                        <h2>{{solutionGroup.solutionGroup}}</h2>
                      </div>

                      <div class="spacer"></div>

                      <div class="solution-bottom-row">
                        <div class="solution-summary">
                          Products : {{solutionGroup.countOfProducts}} | Distributed by other :
                          {{solutionGroup.otherDistributor ? 'Yes' : 'No'}}
                        </div>
                      </div>
                    </div>

                    <div class="expand-arrow" (click)="toggleExpand(solutionGroup.solutionGroup, getRowKey('notPurchased', rowIndex))">
                      <svg width="24" height="12" viewBox="0 0 24 12" fill="none" class="sp-location-chevron"
                        xmlns="http://www.w3.org/2000/svg">
                        <path id="DownChevron" d="M1.5 1L6 4.85714L10.5 1" stroke="#006BD3" stroke-width="1.5"
                          stroke-linecap="round" />
                      </svg>
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="solutionGroupRow.length < 3">
                <td *ngFor="let emptyCell of [].constructor(3 - solutionGroupRow.length)"></td>
              </ng-container>
            </tr>

            <tr *ngIf="selectedRowKey === getRowKey('notPurchased', rowIndex) && selectedSolutionGroup">
              <td colspan="3">
                <div class="product-details-container">
                  <div class="product-details-header">
                    <h2>{{selectedSolutionGroup}}</h2>
                    <div class="close-icon expand-close-icon" (click)="toggleExpand(selectedSolutionGroup, getRowKey('notPurchased', rowIndex))">
                      <img src="assets/close-icon.svg" alt="Close icon" />
                    </div>
                  </div>

                  <div class="product-details-table-container" *ngIf="!shouldShowNoLocationsMessage; else noLocationsPurchasedAnyProductsWithinGroupBlock">
                    <app-location-product-details-table [productData]="productData" [rightSection]=false></app-location-product-details-table>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <ng-template #loaderBlock>
    <div class="loader-container">
      <loader [size]="'large'"></loader>
    </div>
  </ng-template>

  <ng-template #noPurchasedSolutionGroupsBlock>
    <div class="no-solutions-message">
      <h2>No Solution Groups Purchased</h2>
    </div>
  </ng-template>

  <ng-template #noNotPurchasedSolutionGroupsBlock>
    <div class="no-solutions-message">
      <h2>No Unpurchased Solution Groups</h2>
    </div>
  </ng-template>

  <ng-template #noLocationsPurchasedAnyProductsWithinGroupBlock>
    <div class="no-solutions-message no-locations-purchased">
      <h2>No locations have purchased any products within this group.</h2>
    </div>
  </ng-template>
</div>

<ng-template #noSolutionsMessageBlock>
  <div class="no-solutions-message">
    <h2>No Solution Groups available</h2>
  </div>
</ng-template>
}
